import get from 'lodash.get';
import { gql } from '@apollo/client';
import getEnrollmentQuery from '../../enrollment/shared/enrollmentQuery';
import getStudentEnrollmentQuery from '../../enrollment/shared/studentEnrollmentQuery';
import getIntercomEnrollmentQuery from '../../enrollment/shared/intercomEnrollmentQuery';
import getExternalStaffQuery from '../../enrollment/shared/externalStaffQuery';
import getAdditionalEnrollmentInfoQuery from '../../enrollment/shared/additionalEnrollmentInfoQuery';
import { PARAM, MES_VERSION } from '../../../constants/shared/ApiConstants';
import ApolloClient, { errorHandler } from './ApolloClient';
import getAmpNavQuery from '../../enrollment/shared/ampNavQuery';

const { DISTRICT, SCHOOL, CLASSE } = PARAM;

export class EnrollmentClient {
    version = MES_VERSION;

    enrollmentInfoParamKeys = {
        districtKey: DISTRICT,
        schoolKey: SCHOOL,
        classeKey: CLASSE,
    };

    getClient() {
        if (!this.client) {
            this.client = ApolloClient;
        }
        return this.client;
    }

    getCommonEnrollmentInfoParams = ({ district, school, classe }) => {
        const { districtKey, schoolKey, classeKey } = this.enrollmentInfoParamKeys;
        return [
            ...(district ? [`${districtKey}: "${district}"`] : []),
            ...(school ? [`${schoolKey}: "${school}"`] : []),
            ...(classe ? [`${classeKey}: "${classe}"`] : []),
        ];
    };

    getEnrollmentInfo = params => {
        return this.getClient()
            .query({
                query: gql`
                    ${getEnrollmentQuery(this.version, this.getEnrollmentInfoParams(params))}
                `,
            })
            .then(result => get(result, `data.getEnrollmentResolvers_${this.version}`, {}))
            .catch(errorHandler);
    };

    getAmpNavData = () => {
        return this.getClient()
            .query({
                query: gql`
                    ${getAmpNavQuery()}
                `,
            })
            .then(result => get(result, `data.getStaffConfig`, {}))
            .catch(errorHandler);
    };

    getAdditionalEnrollmentInfo = params => {
        return this.getClient().query({
            query: gql`
                ${getAdditionalEnrollmentInfoQuery(
                    this.version,
                    this.getEnrollmentInfoParams(params),
                )}
            `,
        });
    };

    getStudentsEnrollmentInfo = (studentsIds, isDemoClass) => {
        return this.getClient()
            .query({
                query: gql`
                    ${getStudentEnrollmentQuery(this.version, studentsIds, isDemoClass)}
                `,
            })
            .then(result => get(result, `data.getStudentEnrollment_${this.version}`, {}))
            .catch(errorHandler);
    };

    getIntercomInfo = () => {
        return this.getClient()
            .query({
                query: gql`
                    ${getIntercomEnrollmentQuery(this.version)}
                `,
            })
            .then(result => get(result, `data.getIntercomEnrollment_${this.version}`, {}))
            .catch(errorHandler);
    };

    getExternalStaff = assessorIds => {
        return this.getClient()
            .query({
                query: gql`
                    ${getExternalStaffQuery(this.version, assessorIds)}
                `,
            })
            .then(result => get(result, `data.getStaffInfo_${this.version}`, []))
            .catch(errorHandler);
    };
}

export default new EnrollmentClient();
